export function PercentBar({ actual = 0, planned = null, testId }) {
  const actualPct = Math.max(0, Math.min(100, Number(actual || 0) * 100));
  const plannedPct = planned !== null && planned !== undefined ? Math.max(0, Math.min(100, Number(planned) * 100)) : null;
  return (
    <div data-testid={testId} className="relative h-1.5 w-full min-w-[64px] rounded-full bg-slate-200 dark:bg-slate-800">
      <div className="absolute inset-y-0 left-0 rounded-full bg-[#910029] transition-all" style={{ width: `${actualPct}%` }} />
      {plannedPct !== null && (
        <div
          className="absolute -top-[3px] h-3 w-0.5 rounded bg-sky-500"
          style={{ left: `calc(${plannedPct}% - 1px)` }}
          title={`Planned ${plannedPct.toFixed(1)}%`}
        />
      )}
    </div>
  );
}
